module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hammer-up"
  }, [_c('div', {
    ref: "hammer",
    staticClass: "hammer"
  }, [_c('canvas', {
    ref: "hammerIn",
    attrs: {
      "tag": "canvas",
      "id": "theCanvas"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isButton),
      expression: "isButton"
    }],
    staticClass: "pdf-button"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currPageNumber,
      "page-size": 1,
      "layout": "prev, pager, next",
      "total": _vm.doc.numPages
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd99b7fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pdf-desktop.vue
// module id = 618
// module chunks = 2